import * as THREE from "three";

export default class controlPanel extends THREE.Object3D {
	constructor(digitization,sustainability,individualprocesses, resetword, todaycity, featurecity ) {
		super();

        let activestate = null;
		const digital = document.getElementById("digitalisierung");
		const nachhaltig = document.getElementById("nachhaltigkeit");
		const individuelle= document.getElementById("individuelleprozesse");
		const reset = document.getElementById("resetcontrol");
		const todaytime = document.getElementById("today");
		const featuretime = document.getElementById("feature");
		const home = document.getElementById("home");

		digital.addEventListener("click", () => selectActiveControl(digital,digitalisierung));
		nachhaltig.addEventListener("click", () => selectActiveControl(nachhaltig,nachhaltigkeit));
		individuelle.addEventListener("click", () => selectActiveControl(individuelle, individuelleprozesse));
		reset.addEventListener("click", () => selectActiveControl(reset, resetcontrol));
		todaytime.addEventListener("click", () => selectActiveControl(todaytime, today));
		featuretime.addEventListener("click", () => selectActiveControl(featuretime, feature));
		home.addEventListener("click", () => selectActiveControl(home, homebutton));

        function selectActiveControl(activeControl,changeActiveFunction) {
			if (activeControl.classList.contains("active")) {
				return;
			}

			digital.classList.remove("active");
			nachhaltig.classList.remove("active");
			individuelle.classList.remove("active");
			reset.classList.remove("active");
			todaytime.classList.remove("active");
			featuretime.classList.remove("active");
			home.classList.remove("active");
            
			activeControl.classList.add("active");
			changeActiveFunction();
		}

		function digitalisierung() {
			if(activestate != 6){
				digitization()
				activestate = 1
			}
			else{
				resetword()
				setTimeout(() => {
					digitization()
					activestate = 1
				}, 1000);
			}
		}

		function nachhaltigkeit() {
			if(activestate != 6){
			sustainability()
            activestate = 2
			}
			else{
				resetword()
				setTimeout(() => {
					sustainability()
					activestate = 2
				},1000);
			}
		}

		function individuelleprozesse() {
			if(activestate != 6){
			individualprocesses()
            activestate = 3
			}
			else{
				resetword()
				setTimeout(() => {
					individualprocesses()
					activestate = 3
			},1000);
			}
		}

		function resetcontrol() {
            if(activestate == 1 || activestate == 2 || activestate == 3){
                activestate  = null
				reset.classList.remove("active");
				selectActiveControl(todaytime, today)
                resetword()
            }
            else{
				reset.classList.remove("active");
				selectActiveControl(todaytime, today)
            }
		}

		function today() {
			todaycity()
		}

		function feature() {
			activestate  = 6
			featurecity()
		}

		function homebutton() {
			activestate  = null
			home.classList.remove("active");
			const overlay = document.getElementById("overlay");
			overlay.classList.remove("hidden");
		}

        selectActiveControl(todaytime, today)
	}
}